import { ReactNode } from "react";
import tw from "src/utils/tw";

interface Props {
  className?: string;
  children: ReactNode;
}

export default function SidebarContent(props: Props) {
  return (
    <div
      id="sidebar"
      className={tw(
        "sm:border-r-none h-full w-[200px] border-r border-borderGray bg-bgGray p-4 pb-16 sm:h-auto sm:w-auto sm:p-0 sm:pt-4 md:overflow-hidden md:overflow-y-auto",
        props.className
      )}
    >
      {props.children}
    </div>
  );
}
